import clsx from "clsx";
import * as moment from "moment/moment";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Horloge } from "../../assets/lhorloge.svg";
import { ReactComponent as Partager } from "../../assets/partager.svg";
import { ReactComponent as Facebook } from "../../assets/Facebook.svg";
import { ReactComponent as Twitter } from "../../assets/Twitter.svg";
import { ReactComponent as Pinterest } from "../../assets/pinterest.svg";
import { ReactComponent as Mail } from "../../assets/mail.svg";
import { useOnClickOutside } from "../../hooks";
import { displayFormat } from "../../shared/tools";
import style from "./style.module.scss";

export const Share = ({ name, date, time, isDesktop, imageurl, titlePost }) => {
  const [showSocials, setShowSocials] = useState(isDesktop);
  const ref = useRef();
  // React i18next
  const { t } = useTranslation();

  useOnClickOutside(ref, () => setShowSocials(false));

  const dateToPrint = moment(date).format(displayFormat());
  const mailSubject = t("Here is an article you might like");
  const descriptionSubject = `${t(
    "The article talks about"
  )} "${titlePost}" %0D%0A%0D%0A ${t("Here is the link")}:`;

  return (
    <div className={style.share}>
      <div className={style.metadata}>
        <div className={style.authorName}>
          <b>{name}</b>
        </div>
        <div className={style.date}>
          {t("on")} {dateToPrint}
        </div>
      </div>
      <div className={style.other}>
        <div className={style.read}>
          <Horloge />
          {time} {t("min read")}
        </div>
        {isDesktop && <div className={style.separator}></div>}

        <div className={style.socials} ref={ref}>
          <div
            className={clsx(
              style.shareIcon,
              !isDesktop && showSocials && style.hover
            )}
            onClick={() => {
              !isDesktop && setShowSocials(true);
            }}
          >
            <Partager />
          </div>
          {isDesktop && t("Share")}
          {(isDesktop || showSocials) && (
            <div className={style.socialBlock}>
              <a
                className={style.social}
                href={
                  "https://www.twitter.com/share?url=" + window.location.href
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <Twitter />
              </a>
              <a
                className={style.social}
                href={
                  "https://www.facebook.com/sharer.php?u=" +
                  window.location.href
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <Facebook />
              </a>
              {imageurl && (
                <a
                  className={style.social}
                  href={`https://pinterest.com/pin/create/link/?url=${window.location.href}&media=${imageurl}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Pinterest />
                </a>
              )}
              <a
                href={`mailto:?subject=${mailSubject}&body=${descriptionSubject}${window.location.href}`}
                className={style.social}
              >
                <Mail />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Share;
